export type EnvironmentLabel = {
  text: string;
  bannerClassName: string;
};

const ENVIRONMENT_LABELS: Record<string, EnvironmentLabel> = {
  prod: { text: "PRODUCTION", bannerClassName: "bg-fg-error-primary border-error_subtle" },
  demo: { text: "DEMO", bannerClassName: "bg-brand-solid border-error_subtle" },
};

const DEFAULT_ENVIRONMENT_LABEL: EnvironmentLabel = {
  text: "DEV",
  bannerClassName: "bg-black border-white/10",
};

export const resolveEnvironmentLabel = (stage: string | undefined): EnvironmentLabel =>
  (stage ? ENVIRONMENT_LABELS[stage] : undefined) ?? DEFAULT_ENVIRONMENT_LABEL;
